export default __webpack_public_path__ + "static/media/leito-cama.d0cf78d7.svg";